import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useSession } from '../context/SessionContext';

export function UploadPage() {
  const { authenticated, startKeyra } = useSession();
  const navigate = useNavigate();
  const [file, setFile] = useState<File | null>(null);
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!authenticated) {
    return (
      <main className="page">
        <h1 style={{ fontFamily: 'var(--font-display)' }}>Upload</h1>
        <p className="muted">Uploading requires Continue with Keyra.</p>
        <button type="button" className="btn primary" onClick={() => void startKeyra('/upload')}>
          Continue with Keyra
        </button>
      </main>
    );
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!file) return;
    setBusy(true);
    setError(null);
    try {
      const init = await api.initUpload({
        filename: file.name,
        contentType: file.type || 'application/octet-stream',
        byteSize: file.size,
      });
      setStatus('Uploading to quarantine…');
      await api.uploadBytes(init.uploadId, file);
      setStatus('Finalizing & queuing conversion…');
      const done = await api.completeUpload(init.uploadId);
      setStatus(`Asset ${done.assetId} created (${done.status ?? 'private'})`);
      navigate(`/library`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Upload failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="page">
      <h1 style={{ fontFamily: 'var(--font-display)' }}>Upload a file</h1>
      <p className="muted">
        Original bytes remain immutable. Native conversion runs on the server. Unknown formats may be
        archived but will not appear as successfully converted.
      </p>
      <form className="panel" style={{ maxWidth: 520, marginTop: '1rem' }} onSubmit={onSubmit}>
        <input
          type="file"
          accept=".glb,.gltf,.obj,.stl,.ply,.blend,.fbx,.dae,.png,.jpg,.jpeg"
          onChange={(e) => setFile(e.target.files?.[0] ?? null)}
          required
        />
        <div className="row" style={{ marginTop: '0.85rem' }}>
          <button className="btn primary" type="submit" disabled={busy || !file}>
            Upload
          </button>
          <Link className="btn" to="/create">
            Or describe an object
          </Link>
        </div>
        {status && <p className="muted">{status}</p>}
        {error && <p className="err">{error}</p>}
      </form>
    </main>
  );
}
